import type { ActKc3TotalData } from 'gql/graphql';
import { UerTotal_AlcTypeEnum as UerTotalAlcTypeEnum } from 'gql/graphql';
import { formatNumberToRu } from 'utils';

import type { CellClassParams, ColDef, ColGroupDef } from 'ag-grid-community';
import { useMemo } from 'react';

import { CostCell, NameCell } from '../cellRenderers';

const cellClassRules = (isNumeric: boolean) => (params: CellClassParams<ActKc3TotalData>) => {
    const boldStyle =
        (params?.data?.totalType &&
            [
                UerTotalAlcTypeEnum.Gross,
                UerTotalAlcTypeEnum.Tax,
                UerTotalAlcTypeEnum.TotalCustomerLimitsChapter1_9,
            ].includes(params?.data?.totalType)) ||
        params?.data?.isHeadLine
            ? 'boldText'
            : '';

    const rightAlignedStyle = isNumeric ? 'ag-right-aligned-cell' : '';

    return `${boldStyle} ${rightAlignedStyle}`;
};

export const useTotalsColumns = ({
    toggleOthersCollapse,
    othersCollapseState,
    hasNotOthersData,
}: {
    toggleOthersCollapse: () => void;
    othersCollapseState: boolean;
    hasNotOthersData: boolean;
}) =>
    useMemo<(ColDef<ActKc3TotalData> | ColGroupDef<ActKc3TotalData>)[]>(
        () => [
            {
                headerName: 'Наименование',
                field: 'name',
                flex: 3,
                minWidth: 150,
                cellRenderer: NameCell,
                cellRendererParams: {
                    toggleOthersCollapse,
                    othersCollapseState,
                    hasNotOthersData,
                },
                cellClass: cellClassRules(false),
            },
            {
                headerName: 'Стоимость выполненных работ и затрат,руб',
                marryChildren: true,
                children: [
                    {
                        headerName: 'С начала проведения работ',
                        field: 'startWorkCost',
                        flex: 1,
                        minWidth: 150,
                        valueFormatter: ({ value }) => formatNumberToRu(value, 2),
                        cellRenderer: CostCell,
                        cellRendererParams: {
                            hideHeadLineValue: true,
                        },
                        cellClass: cellClassRules(true),
                    },
                    {
                        headerName: 'С начала года',
                        field: 'startYearCost',
                        flex: 1,
                        minWidth: 150,
                        valueFormatter: ({ value }) => formatNumberToRu(value, 2),
                        cellRenderer: CostCell,
                        cellRendererParams: {
                            hideHeadLineValue: true,
                        },
                        cellClass: cellClassRules(true),
                    },
                    {
                        headerName: 'В том числе за отчетный период',
                        field: 'reportingPeriodCost',
                        flex: 1,
                        minWidth: 150,
                        valueFormatter: ({ value }) => formatNumberToRu(value, 2),
                        cellRenderer: CostCell,
                        cellClass: cellClassRules(true),
                    },
                ],
            },
        ],
        [hasNotOthersData, othersCollapseState, toggleOthersCollapse],
    );
